import React, { useEffect, useState } from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

import StarRatingComponent from "react-star-rating-component";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { FiShare2 } from "react-icons/fi";
import GaleryProduct, { images } from "./GaleryProduct";

import { useParams } from "react-router-dom";
import { useLazyProductBySlugQuery } from "../../../utils/api/product/product.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { AppStorage } from "../../../utils/storage";
import { Color } from "../../../utils/theme";
import Swal from "sweetalert2";
import { onSetPanier } from "../../../redux/slice/User.slice";
import Fade from "react-reveal/Fade";
import {
  addCartProduct,
  getCartCount,
  getTotalAmount,
} from "../../../redux/slice/useCartSlice";
import {
  useAddProductCartMutation,
  useGetVendeurByApiKeyQuery,
} from "../../../utils/api/product/product.api";
import { useLazyFavoriteByUserQuery } from "../../../utils/api/favories/favorie.api";
import { ApiBaseUrl } from "../../../utils/http";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { formatCurrency, parseLocaleNumber, roundMoneyAmount } from "../../../utils/Utils";
import {
  getEffectiveCatalogUnitPrice,
  getLowestWholesaleTier,
  hasProductStock,
  isProductStockUnlimited,
  isVariationInStock,
  isVariationStockUnlimited,
  needsSizeSelection,
} from "../../../utils/catalogProductPrice";
import {
  type CartVariation,
  getDistinctColorVariations,
  hasDisplayableCouleur,
  normalizeVariationValue,
} from "../../../utils/cartVariation";
import { VendeurApikey } from "../../../utils/http";
import {
  buildCatalogPath,
  getCatalogVendeur,
  isCatalogPath,
} from "../../../catalog/catalogTenant";
import TemplateNavbar from "../../shared/TemplateNavbar/TemplateNavbar";
import { getVendeur } from "../../HomePage/HomePage";
import { useShopTvaSettings } from "../../../catalog/useShopDevise";

const ProduitItemPage = ({ min = 0, max = 5000, step = 1 }) => {
  const isCatalog = isCatalogPath();
  const catalogVendeur = getCatalogVendeur();
  const tvaSettings = useShopTvaSettings();
  const Vendeur =
    isCatalog && catalogVendeur
      ? { devise: catalogVendeur.devise }
      : getVendeur();

  // const [item] = useProductFromLocation();
  const dispatch = useAppDispatch();

  const [item] = images;

  const { slug } = useParams<{ slug: string }>();
  const { user, token } = useAppSelector((s) => s?.user);
  const [showProfil, setShowProfil] = useState(true);
  const [variationActive, setVariationActive] = useState<any>();
  const [variations, setVariations] = useState<any>([]);
  const [validation, setValidation] = useState<boolean>(false);
  const [showValidation, setShowValidation] = useState<boolean>(false);
  const [imagesProduit, setImagesProduit] = useState<any>();
  const [tailles, setTailles] = useState<any>();
  const [tailleActive, setTailleActive] = useState<any>();
  const [findBySlug, { data, isError, isLoading }] =
    useLazyProductBySlugQuery();
  const [findByFavorisSlug, { data: favoris }] = useLazyFavoriteByUserQuery();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const navigate = useNavigate();
  const [count, setCount] = React.useState(1);
  const [addToCart] = useAddProductCartMutation();
  const maxLength = 324
  const [isExpanded, setIsExpanded] = useState(false);

useEffect(() => {
  setIsExpanded(false);
}, [data?.slug]);
const isTruncated = (data?.description?.length ?? 0) > maxLength

 const toggleExpanded = () => {
  setIsExpanded((prev) => !prev);
};

  useEffect(() => {
    if (slug) {
      findBySlug(slug as string);
      findByFavorisSlug(user?.slug as string);
    }
  }, [slug]);

  const handalevalidation = () => {
    setValidation(false);
    setShowValidation(true);

    setTimeout(() => {
      setShowValidation(false);
    }, 3000);
  };

  useEffect(() => {
    const inStock =
      data?.variations?.filter((v) => isVariationInStock(v)) ?? [];
    const productHasColors = hasDisplayableCouleur(inStock);

    const firstVariation = productHasColors
      ? getDistinctColorVariations(inStock)[0]
      : inStock[0];

    if (
      data?.type == "taille_unique" ||
      data?.type == "taille_unique_avec_couleur"
    ) {
      setValidation(true);
      setShowValidation(false);
      const firstVariation = productHasColors
        ? getDistinctColorVariations(inStock)[0]
        : inStock[0];
      if (firstVariation) {
        setVariationActive(firstVariation);
        setVariations([firstVariation]);
      } else {
        setVariationActive(null);
        setVariations([]);
      }
      return;
    }

    if (firstVariation) {
      setVariationActive(firstVariation);
      setVariations([firstVariation]);
      if (!productHasColors && firstVariation.taille) {
        setTailleActive(firstVariation.taille);
      }
    } else {
      setVariationActive(null);
      setVariations([]);
    }
  }, [data]);

  useEffect(() => {
    setImagesProduit(variationActive?.images);
    const inStock =
      data?.variations?.filter((x) => isVariationInStock(x)) ?? [];
    const productHasColors = hasDisplayableCouleur(inStock);

    setTailles(
      productHasColors
        ? inStock.filter(
            (x) =>
              normalizeVariationValue(x.couleur) ===
              normalizeVariationValue(variationActive?.couleur),
          )
        : inStock,
    );
  }, [variationActive, data]);

  function SuccessPopup() {
    Swal.fire({
      icon: "success",
      iconColor: Color.success,
      confirmButtonColor: Color.success,
      title: "Produit ajouté au panier avec succès !",
      showConfirmButton: false,
      timer: 3000,
    });
  }

  const getSelectedPriceInfo = (quantity: number = count) => {
    const sizeSelected =
      !needsSizeSelection(data) ||
      !!tailleActive ||
      data?.type === "taille_unique" ||
      data?.type === "taille_unique_avec_couleur";
    return getEffectiveCatalogUnitPrice(
      data,
      variationActive,
      quantity,
      { sizeSelected },
      tvaSettings,
    );
  };

  // Fonction pour ajouter un produit au panier
  const ajouterAuPanier = async () => {
    findBySlug(slug as string);

    const prixApplique = getSelectedPriceInfo().displayPrice;

    let produit = {
      produit: data,
      prix: prixApplique,
      quantite: count,
      stock: data?.stock,
      variations: variations,
      vendeur: data?.vendeur?.id,
    };

    dispatch(addCartProduct(produit));
    dispatch(getCartCount());
    dispatch(getTotalAmount());
    SuccessPopup();
  };

  const onSelectColor = (item) => {
    setVariationActive(item);
    setVariations([item]);
    if (
      data?.type == "taille_unique" ||
      data?.type == "taille_unique_avec_couleur"
    ) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  const onSelectSize = (item) => {
    setTailleActive(item?.taille);
    setVariationActive(item);
    setVariations([item]);
    setValidation(true);
  };

  const ColorVariationItem = ({
    color,
    isActive,
    variation,
  }: {
    color?: string | null;
    isActive?: number | string;
    variation?: any;
  }) => {
    const displayColor = normalizeVariationValue(color);
    if (!displayColor) return null;

    return (
      <div
        className={
          variationActive?.id == isActive ? "btn_color_wrapper" : "btn_color"
        }
      >
        <label
          role="button"
          className={`btn btn_color_choose`}
          style={{ background: displayColor }}
          onClick={() => onSelectColor(variation)}
        ></label>

        <input
          type="radio"
          name="variation_color"
          id="variation_color"
          value={variation?.id}
        />
      </div>
    );
  };

  const SizeVariationItem = ({
    size,
    variation,
  }: {
    size: string;
    variation: any;
  }) => {
    return (
      <label
        role="button"
        className={
          variation?.taille == tailleActive
            ? "btn btn_size_choose active "
            : "btn btn_size_choose"
        }
        onClick={() => onSelectSize(variation)}
      >
        <input
          type="radio"
          name="variation_size"
          id="variation_size"
          value={variation?.id}
        />

        {size}
      </label>
    );
  };

  const decrement = (e) => {
    setCount((prevValue) => Math.max(prevValue - step, min));
  };

  const increment = (e) => {
    setCount((prevValue) => Math.min(prevValue + step, max));
  };

  const handleChange = (e) => {
    const inputValue = parseInt(e.target.value, 10);

    if (!isNaN(inputValue)) {
      setCount(Math.min(Math.max(inputValue, min), max));
    } else {
      setCount(0);
    }
  };

  const handleAddFavoris = (id) => {
    let favorie = favoris?.find((x) => x?.produit?.id == id);

    let fd = new FormData();

    fd.append("user", user?.id);
    fd.append("produit", id);

    if (favorie) {
      axios
        .delete(ApiBaseUrl + `/api/favoris/${favorie?.slug}`, config)
        .then((response) => {
          findBySlug(slug as string);
          findByFavorisSlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    } else {
      axios
        .post(ApiBaseUrl + "/api/favoris/", fd, config)
        .then((response) => {
          findBySlug(slug as string);
          findByFavorisSlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    }
  };

  const onToggleFavorite = (id) => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: `Veuilliez vous connecter pour ajouter un produit au favoris .`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 6000,
      });
    } else {
      handleAddFavoris(id);
    }
  };

  const isFavorite = (id) => {
    const favorie = favoris?.find((x) => x?.produit?.id == id);
    return !!favorie;
  };

  const acheterMaintenant = () => {
    if (!validation) {
      handalevalidation();
      return;
    }
    const prixApplique = getSelectedPriceInfo().displayPrice;
    const produit = {
      produit: data,
      prix: prixApplique,
      quantite: count,
      stock: data?.stock,
      variations: variations,
      vendeur: data?.vendeur?.id,
    };
    dispatch(addCartProduct(produit));
    navigate(isCatalog ? buildCatalogPath("/valider-commande") : "/panier");
  };

  const handleShare = async () => {
    const productUrl = isCatalog
      ? `${window.location.origin}${buildCatalogPath(`/produit/${data?.slug}`)}`
      : `${window.location.origin}/produit/${data?.slug}`;
    const shareText = `Découvrez ${data?.nom} - ${formatCurrency(
      getSelectedPriceInfo().displayPrice,
      Vendeur?.devise,
    )}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: data?.nom,
          text: shareText,
          url: productUrl,
        });
      } catch {
        // Partage annulé ou erreur
      }
    } else {
      try {
        await navigator.clipboard.writeText(productUrl);
        Swal.fire({
          icon: "success",
          title: "Lien copié !",
          text: "Le lien du produit a été copié dans le presse-papiers.",
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 2000,
        });
      } catch {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Impossible de copier le lien.",
          iconColor: Color.danger,
        });
      }
    }
  };

  const storeName =
    catalogVendeur?.nom_boutique ||
    catalogVendeur?.nom_de_la_boutique ||
    "Nom de la boutique";

  const priceInfo = data ? getSelectedPriceInfo(count) : null;
  const wholesaleHint = data
    ? getLowestWholesaleTier(data, variationActive)
    : null;

  const pageInner = (
    <>
      <Fade bottom>
        <div
          className="content-back-to"
          onClick={(e) => {
            e?.preventDefault();
            navigate(-1);
          }}
        >
          <HiOutlineArrowLeft style={{ fontSize: 18 }} />
          <span className="ps-2 go-back-btn">RETOUR</span>
        </div>
      </Fade>
      {isLoading && (
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3 dis-flex" key={0}>
                <div className="item-stat-dashboad-view ">
                  <div className="content-item-stat-dashboad-view mt-2">
                    <div className="content-item-icon-stat-dashboard-view">
                      <Skeleton className="img-icon-dash-view" width={`70%`} />
                      <Skeleton className="img-icon-dash-view" width={`70%`} />
                    </div>
                  </div>
                  <div className="content-stat-dashboard-view">
                    <div className="content-text-item-stat-dashboad-view">
                      <div className="icon-item-stat-dashboad-view">
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-3 dis-flex" key={0}>
                <div className="item-stat-dashboad-view ">
                  <div className="content-item-stat-dashboad-view mt-2">
                    <Skeleton
                      className="titre-item-stat-dashboad-view mb-2"
                      width={`70%`}
                    />
                    <Skeleton
                      className="titre-item-stat-dashboad-view mb-2"
                      width={`50%`}
                    />
                    <Skeleton
                      className="titre-item-stat-dashboad-view mb-2"
                      width={`30%`}
                    />
                  </div>
                  <div className="content-stat-dashboard-view">
                    <div className="content-text-item-stat-dashboad-view">
                      <div className="icon-item-stat-dashboad-view">
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                        <Skeleton
                          className="titre-item-stat-dashboad-view mb-2"
                          width={`70%`}
                        />
                        <Skeleton
                          className="titre-item-stat-dashboad-view mb-2"
                          width={`50%`}
                        />
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!isLoading && (
            <div className="row row-product-item-page   pb-4">
              <div className="col-lg-6 col-md-12 col-left-product-item-page d-flex">
                <div className="content-col-left-product-item-page container-product-item-page">
                  <GaleryProduct
                    pictures={
                      data?.type == "taille_unique"
                        ? data?.images
                        : data?.variations && data?.variations[0]?.images
                          ? imagesProduit
                            ? imagesProduit
                            : data?.variations[0]?.images
                          : null
                    }
                  />
                  {hasDisplayableCouleur(
                    data?.variations?.filter((v) => isVariationInStock(v)),
                  ) ? (
                    <div className="custom_container variation_content container-product-colors product-variations-under-image">
                      <div className="d-flex align-items-center gap-3 avalaible_colors_wrapper">
                        {getDistinctColorVariations<CartVariation>(
                          (data?.variations?.filter((v) =>
                            isVariationInStock(v),
                          ) ?? []) as CartVariation[],
                        ).map((item, key) => (
                          <ColorVariationItem
                            color={item.couleur}
                            isActive={item.id}
                            variation={item}
                            key={key}
                          />
                        ))}
                      </div>
                    </div>
                  ) : null}
                  {data?.type != "taille_unique" &&
                  data?.type != "taille_unique_avec_couleur" ? (
                    <div className="custom_container variation_content container-product-sizes product-variations-under-image">
                      <div className="d-flex align-items-center gap-3 avalaible_sizes_wrapper">
                        {!!tailles &&
                          tailles.map((item, key) => (
                            <SizeVariationItem
                              size={item.taille}
                              variation={item}
                              key={key}
                            />
                          ))}
                      </div>
                    </div>
                  ) : null}
                  {showValidation && (
                    <div className="alert alert-danger mt-1" role="alert">
                      Veillez choisir une taille
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-right-product-item-page d-flex">
                <div className="content-col-left-product-item-page container-product-item-page">
                  <Fade bottom>
                    <h1 className="name-product mb-2">{data?.nom}</h1>
                  </Fade>
                  <Fade bottom>
                    <p className="category-product-name mb-1">
                      Categorie: {data?.categorie?.nom}
                    </p>
                  </Fade>

                  <div className="custom_container container-product-description pb-4">
                    <Fade bottom>
                      <p className="custom_sm__title">Description</p>
                    </Fade>
                   <div className="description-wrapper">
  <div
    className={`text-describe-product-item-detail ${
      isExpanded ? "expanded" : "collapsed"
    }`}
  >
    {data?.description}
  </div>

  <button
  type="button"
  className="btn-see-more-product"
  onClick={() => setIsExpanded((prev) => !prev)}
>
  {isExpanded ? "Voir moins" : "Voir plus"}
</button>
</div>
                  </div>

                  <div className="custom_container container-product-price pb-4">
                    <Fade bottom>
                      {priceInfo?.hasPromo ? (
                        <>
                          <span className="custom_sm__price_promos pb-3">
                            {priceInfo.isFromPrice ? "À partir de " : ""}
                            {formatCurrency(
                              priceInfo.displayPrice,
                              Vendeur?.devise,
                            )}
                          </span>
                          <span className="custom_sm__price_promos_bare pb-3">
                            {formatCurrency(
                              priceInfo.originalPrice,
                              Vendeur?.devise,
                            )}
                          </span>
                        </>
                      ) : (
                        <p className="custom_sm__price pb-3">
                          {priceInfo?.isFromPrice ? "À partir de " : ""}
                          {formatCurrency(
                            priceInfo?.displayPrice ?? 0,
                            Vendeur?.devise,
                          )}
                        </p>
                      )}
                    </Fade>
                  </div>
                  <div className="container-quantite-produit mb-4">
                    <p className="title-quantity-product">Quantité</p>
                    {/* <div className="counter mt-3 mb-5">
                    <Counter setCount={setCount} count={count} produit={data} user={user} />
                  </div> */}
                    <div className="btn-wrap">
                      <button
                        className="btn decrement-btn btn-counter-item"
                        disabled={count <= 1}
                        onClick={(e) => decrement(e)}
                      >
                        −
                      </button>
                      <div className="num">
                        <input
                          type="number"
                          value={count}
                          onChange={handleChange}
                          className="input-counter-item "
                        />
                      </div>
                      {(() => {
                        const unlimited =
                          isProductStockUnlimited(data) ||
                          (data?.type !== "taille_unique" &&
                            isVariationStockUnlimited(variationActive));
                        const canIncrement =
                          unlimited ||
                          (data?.type === "taille_unique"
                            ? count < Number(data?.stock)
                            : count < Number(variationActive?.quantite));
                        return (
                          canIncrement && (
                            <button
                              className="btn increment-btn btn-counter-item"
                              onClick={(e) => increment(e)}
                            >
                              +
                            </button>
                          )
                        );
                      })()}
                    </div>
                  </div>
                  {wholesaleHint ? (
                    <p
                      className="mb-3"
                      style={{
                        color: priceInfo?.isWholesale ? "#E58924" : "#6B7280",
                        fontSize: 13,
                        marginTop: -8,
                      }}
                    >
                      {priceInfo?.isWholesale
                        ? `Prix en gros appliqué : ${formatCurrency(
                            priceInfo.displayPrice,
                            Vendeur?.devise,
                          )} / unité`
                        : `Prix en gros dès ${wholesaleHint.min_quantity} : ${formatCurrency(
                            Number(wholesaleHint.unit_price),
                            Vendeur?.devise,
                          )} / unité`}
                    </p>
                  ) : null}
                  {(() => {
                    const unlimited =
                      isProductStockUnlimited(data) ||
                      (data?.type !== "taille_unique" &&
                        isVariationStockUnlimited(variationActive));
                    if (unlimited || data?.type === "taille_unique") return null;
                    const maxQty = Number(variationActive?.quantite) || 0;
                    if (count <= maxQty) return null;
                    return (
                      <div className="alert alert-danger mt-1" role="alert">
                        {maxQty > 0
                          ? `La quantité maximale est de ${variationActive?.quantite}`
                          : `Cette variation est en rupture de stock`}
                      </div>
                    );
                  })()}
                  <div className="container-quantite-produit">
                    <p className="title-quantity-product">Total</p>
                    <p className="title-quantity-product">
                      {formatCurrency(
                        (priceInfo?.displayPrice ?? 0) * count,
                        Vendeur?.devise,
                      )}
                    </p>
                  </div>
                  <div className="container-btn-add-to-cart-product mt-4">
                    <div className="product-action-buttons-row">
                      {(count > 0 &&
                        hasProductStock(data) &&
                        (data?.type === "taille_unique"
                          ? true
                          : isVariationInStock(variationActive) &&
                            (isVariationStockUnlimited(variationActive) ||
                              count <=
                                Number(variationActive?.quantite)))) ? (
                        <>
                          <button
                            className="btn btn-buy-now"
                            onClick={() =>
                              validation
                                ? acheterMaintenant()
                                : handalevalidation()
                            }
                          >
                            Acheter maintenant
                          </button>
                          <button
                            className="btn btn-add-to-cart"
                            onClick={() =>
                              validation
                                ? ajouterAuPanier()
                                : handalevalidation()
                            }
                          >
                            Ajouter au panier
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-buy-now"
                            disabled
                          >
                            Acheter maintenant
                          </button>
                          <button
                            className="btn btn-add-to-cart"
                            disabled
                          >
                            Ajouter au panier
                          </button>
                        </>
                      )}
                    </div>
                    <div className="product-secondary-buttons-row">
                      <button
                        type="button"
                        className="btn btn-share"
                        onClick={handleShare}
                      >
                        <FiShare2 />
                        <span className="ps-2">Partager</span>
                      </button>
                      <button
                        type="button"
                        className="btn btn-favorite"
                        onClick={() => onToggleFavorite(data?.id)}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <span
                            className="spinner-border spinner-border-sm me-1 d-inline-block"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : isFavorite(data?.id) ? (
                          <AiFillHeart style={{ color: "var(--primary-color)" }} />
                        ) : (
                          <AiOutlineHeart />
                        )}
                        <span className="ps-2">Favoris</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

    </>
  );

  if (isCatalog) {
    return (
      <div className="template-wrapper">
        <TemplateNavbar vendeurName={storeName} compact />
        <div className="main-content template-product-detail">{pageInner}</div>
      </div>
    );
  }

  return (
    <div className="landing-page-component">
      <TemplateNavbar />
      <div className="page-content bg-white">
        <div className="container-easy-market">{pageInner}</div>
      </div>
    </div>
  );
};

export default ProduitItemPage;
